import { ChevronLeft, ChevronRight } from "@mui/icons-material";

export const CustomPrevArrow = ({ onClick, currentSlide }) => {
  return currentSlide > 0 ? (
    <button 
      className="absolute left-1 top-[42%] -translate-y-1/2 z-10 w-10 h-10 bg-white rounded-full shadow-sm border-0 text-stone-800 flex items-center justify-center" 
      onClick={onClick}
    >
      <ChevronLeft fontSize="small" />
    </button>
  ) : null;
};

export const CustomNextArrow = ({ onClick, currentSlide, slideCount }) => {
  return currentSlide < slideCount - 4 ? (
    <button 
      className="absolute right-1 top-[42%] -translate-y-1/2 z-10 w-10 h-10 bg-white rounded-full shadow-sm border-0 text-stone-800 flex items-center justify-center" 
      onClick={onClick}
    >
      <ChevronRight fontSize="small" />
    </button>
  ) : null;
};

export const CustomNextArrowForPopularStyle = ({ onClick, currentSlide, slideCount }) => {
  return currentSlide < slideCount - 3 ? <button className="absolute right-1 top-[42%] -translate-y-1/2 z-10 w-10 h-10 bg-white rounded-full shadow-sm border-0 text-stone-800 flex items-center justify-center" onClick={onClick}>
    <ChevronRight fontSize="small" />
  </button> : null;
};

export const settings = {
  dots: false,
  infinite: false, // Important: infinite false karoge tab currentSlide ka control milega
  arrows: true,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 3,
  prevArrow: <CustomPrevArrow />,
  nextArrow: <CustomNextArrow />,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1
      }
    }
  ]
};
